import type { HowItWorksProps } from "./HowItWorks.types";
import { HowItWorks5StepsDetailed, cardsDetailed5StepsConfig } from "./HowItWorks5StepsDetailed";

export const HOW_IT_WORKS_STATUS_EVENT_UA = ["clicked", "HowItWorks", "HowItWorksCTA"] as const;
export const HOW_IT_WORKS_STATUS_EVENT = {
  event: "cta_click",
  label: "how_it_works_CTA",
  placement: "how_it_works",
} as const;

export const howItWorksExperimentVariationIds = [1321953046412422, 1756795192290370];

export const howItWorksConfig: HowItWorksProps = {
  preheader: "How it works",
  title: "Compensation in 5 steps",
  cards: <HowItWorks5StepsDetailed cards={cardsDetailed5StepsConfig} />,
  buttonText: "Get Compensation Now",
  uaEvent: HOW_IT_WORKS_STATUS_EVENT_UA,
  gaEvent: HOW_IT_WORKS_STATUS_EVENT,
};
